"use client";

import { c as _c } from "react/compiler-runtime";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { useTheme } from "next-themes";
const Toaster = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const t2 = theme as ToasterProps["theme"];
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      pointerEvents: "auto"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props || $[4] !== t2) {
    t4 = <Sonner theme={t2} className="toaster group" style={t3 as React.CSSProperties} {...props} />;
    $[3] = props;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export { Toaster };